<template>
  <v-col cols="12">
    <v-container fluid no-gutters>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title class="subtitle-2">{{clip.title}}</v-card-title>
            <v-card-text>
              <v-timeline align-top dense>
                <v-timeline-item small>
                  <v-row no-gutters>
                    <v-col>
                      <strong>Created at</strong>
                      <div class="caption">{{ getDate }}</div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
                <v-timeline-item small v-if="clip.view_count > 0">
                  <v-row no-gutters>
                    <v-col>
                      <strong>View count</strong>
                      <div class="caption">{{ clip.view_count }} views</div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
                <v-timeline-item small>
                  <v-row no-gutters>
                    <v-col>
                      <div class="caption"><a :href="clip.url" target="_blank" @click="trackClick">view in new window</a></div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card v-if="user !== null && user != undefined">
            <v-list-item>
              <v-list-item-avatar>
                  <v-img :src="user.profile_image_url"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Created by</v-list-item-title>
                <v-list-item-subtitle>{{user.display_name}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card v-if="game !== null && game != undefined">
            <v-list-item>
              <v-list-item-avatar>
                  <v-img :src="getGameThumbnail"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Playing</v-list-item-title>
                <v-list-item-subtitle>{{game.name}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
export default {
  name: 'ClipInformation',
  props: {
    iso: Boolean,
    clip: Object,
    game: Object,
    user: Object
  },
  computed: {
    getDate () {
      if (this.iso) {
        return new Date(Date.parse(this.clip.created_at)).toLocaleString()
      }
      return new Date(this.clip.created_at).toLocaleString()
    },
    getGameThumbnail () {
      if (this.game !== null && this.game !== undefined) {
        return this.game.box_art_url.replace('{height}', '300').replace('{width}', '300')
      }
      return ''
    }
  },
  methods: {
    trackClick () {
      this.$ga.event({
        eventCategory: 'LinkClick',
        eventAction: 'ExternalClip',
        eventLabel: 'Id',
        eventValue: this.clip.id
      })
    }
  }
}
</script>
